import { Capacitor } from '@capacitor/core';

export function registerPwa() {
  if (Capacitor.isNativePlatform() || !('serviceWorker' in navigator)) return;
  // Also revalidate imports: the hosting may apply a browser TTL to .js files.
  const register = () => navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' }).catch(() => {
    // The radio still works if installation/offline storage is unavailable.
  });
  if (document.readyState === 'complete') register();
  else window.addEventListener('load', register, { once: true });
}
